import React, { useRef, useState, useEffect } from "react";
import Webcam from "react-webcam";
import jsQR from "jsqr";
import axios from "axios";
import { CheckToken } from "../../login/AccessToken";
import { TableBody, TableHead } from "@mui/material";
import { Card, Col, Container, Row, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import { displayPatientName } from "../../../utils/displayPatientName";
import showPromptDialog from "../../../components/ShowConfirmDialog/ShowPromptDialog";

const QRCodeReader = () => {
  const webcamRef = useRef(null);
  const [scannedData, setScannedData] = useState("");
  const [healthIdDetails, setHealthIdDetails] = useState("");
  const [patientList, setPatientList] = useState("");
  const [selectedPatient, setSelectedPatient] = useState("");
  const [decodedData, setDecodedData] = useState("");
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [showFinalData, setShowFinalData] = useState(false);
  const [purpose, setPurpose] = useState("");
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  const fetchPatientList = () => {
    if (Token()) {
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
          {
            headers: headers,
          }
        )
        .then((res) => {
          setPatientList(res.data?.data);
        });
    }
  };

  useEffect(() => {
    fetchPatientList();
  }, [authToken]);

  const handleOpenCamera = () => {
    setIsCameraOpen(true);
  };

  const handleCloseCamera = () => {
    setIsCameraOpen(false);
  };

  // useEffect(() => {
  //     if (selectedPatient !== null) {
  //         proceedWithOtherEndpoints(decodedData);
  //     }
  // }, [selectedPatient]);
  useEffect(() => {
    if (selectedPatient !== null && decodedData && selectedPatient) {
      // proceedWithOtherEndpoints(decodedData);
      AddCareContext(decodedData);
    }
  }, [selectedPatient]);

  const handleCapture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      const img = new Image();
      img.onload = function () {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0, img.width, img.height);

        const imageData = ctx.getImageData(0, 0, img.width, img.height);
        const code = jsQR(imageData.data, imageData.width, imageData.height);

        if (code) {
          // toast.success(code.data);
          const decodedData = JSON.parse(code.data);
          setDecodedData(decodedData);
          console.log(decodedData, "decodedData");
          setIsCameraOpen(false);
          // setHealthIdDetails(decodedData)

          const matchedPatient = patientList.find(
            (patient) => patient.abha_id === decodedData.hid
          );
          // setSelectedPatient(matchedPatient)
          console.log("matchedPatient", matchedPatient);
          if (!matchedPatient) {
            const newData = {
              abhaAddress: decodedData.hid,
              abhaNumber: decodedData.hidn,
              firstname: decodedData.name.split(" ")[0] || "",
              middlename:
                decodedData.name.split(" ").slice(1, -1).join(" ") || "",
              lastname: decodedData.name.split(" ").slice(-1).join(" ") || "",
              gender: decodedData.gender,
              dateOfBirth: decodedData.dob.split("-").reverse().join("-") || "",
              country: "INDIA", // Assuming country is always India
              state: decodedData["state_name"].toUpperCase() || "",
              district: decodedData["district_name"].toUpperCase() || "",
              locality: decodedData.address || "",
              pincode: "", // You may need to add pincode data if available
              phoneNumber: decodedData.mobile || "",
              emailId: "", // You may need to add email data if available
              height: "", // You may need to add height data if available
              weight: "", // You may need to add weight data if available
              uploaded_photo: {}, // You may need to add photo data if available
              patientName: `${decodedData.name}` || "",
              yearOfBirth: decodedData.dob.split("-")[2] || "",
              monthOfBirth: decodedData.dob.split("-")[1] || "",
              dayOfBirth: decodedData.dob.split("-")[0] || "",
              healthIdNumber: decodedData.hidn || "",
              healthId: decodedData.hid || "",
            };

            console.log("finalttt", newData);

            axios
              .post(
                `${REACT_APP_BACKEND_ROUTE_URL}add_patient/`,
                JSON.stringify(newData),
                {
                  headers: headers,
                }
              )
              .then((response) => {
                if (
                  response.data.message === "Patient created successfully !!"
                ) {
                  toast.success(response.data.message);
                  // fetchPatientList();
                  setSelectedPatient(response.data.patient);
                  fetchPatientList();

                  // Proceed with other endpoints after patient registration
                  // proceedWithOtherEndpoints(decodedData);
                } else {
                  const message =
                    response.data.message || "An unknown error occurred.";

                  if (message.includes("corrupted")) {
                    toast.error(
                      "The Facility documents uploaded are corrupted. Please try with a different document."
                    );
                  } else if (message.includes("virus")) {
                    toast.error(
                      "The Facility documents uploaded has virus. Please try with a different document."
                    );
                  } else {
                    toast.error(
                      `${response.data.message} Patient Name: ${displayPatientName(response.data.patient.name)}  Patient ID: ${response.data.patient.patient_id}`
                    );
                  }
                }
                console.log(response);
              })
              .catch((error) => {
                console.error("Error:", error);
              });
          } else {
            // Patient found, proceed with other endpoints
            // proceedWithOtherEndpoints(decodedData);
            AddCareContext(decodedData);
          }
        } else {
          toast.error("No QR code found.");
        }
      };
      img.src = imageSrc;
    }
  };

  const proceedWithOtherEndpoints = (decodedData) => {
    console.log("decodedData", decodedData);
    const postData = {
      query: {
        id: decodedData.hid,
        purpose: "KYC_AND_LINK",
        requester: {
          type: "HIP",
          id: sessionStorage.getItem("facility_name"),
        },
        authMode: "DEMOGRAPHICS",
      },
    };
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}auth_init_workflow/`,
        JSON.stringify(postData),
        {
          headers: headers,
        }
      )
      .then((response) => {
        console.log("auth_init_workflow response:", response.data);

        // Call auth_confirm_workflow endpoint if auth_init_workflow was successful
        if (response.data.status !== "") {
          var postData2 = {};
          postData2.credential = {};

          postData2.transactionId = response.data.transaction_id;
          postData2.credential.demographic = {};
          postData2.credential.demographic.name = decodedData.name;
          postData2.credential.demographic.gender = decodedData.gender;
          postData2.credential.demographic.dateOfBirth = decodedData.dob;
          postData2.credential.demographic.authCode = "";
          axios
            .post(
              `${REACT_APP_BACKEND_ROUTE_URL}auth_confirm_workflow/`,
              JSON.stringify(postData2),
              {
                headers: headers,
              }
            )
            .then(async (response2) => {
              console.log("auth_confirm_workflow response:", response2.data);
              console.log("tdata", selectedPatient);
              if (response2.data.status == "Success") {
                var post_data2 = {};
                post_data2.link = {};
                post_data2.link.accessToken = response2.data.access_token;
                post_data2.link.patient = {};
                if (!selectedPatient) {
                  // If selectedPatient is empty, find a matched patient from patientList based on decodedData.hid
                  const matchedPatient = patientList.find(
                    (patient) => patient.abha_id === decodedData.hid
                  );
                  if (matchedPatient) {
                    post_data2.link.patient.referenceNumber =
                      matchedPatient.patient_id;
                    post_data2.link.patient.display = matchedPatient.abha_id;
                  } else {
                    console.log("No matching patient found");
                  }
                } else {
                  // If selectedPatient is not empty, use its data
                  post_data2.link.patient.referenceNumber =
                    selectedPatient.patient_id;
                  post_data2.link.patient.display = selectedPatient.abha_id;
                }
                post_data2.link.patient.careContexts = [];
                var careContextData = {};
                const displayValue = await showPromptDialog(
                  "Enter visit purpose"
                );

                setPurpose(displayValue);
                careContextData.display = displayValue || "";
                post_data2.link.patient.careContexts[0] = careContextData;

                axios
                  .post(
                    `${REACT_APP_BACKEND_ROUTE_URL}add_context_workflow/`,
                    JSON.stringify(post_data2),
                    {
                      headers: headers,
                    }
                  )
                  .then((res) => {
                    console.log("Add Visit Purpose", res.data);
                    if (res.data.status !== "") {
                      toast.error(`Status: ${res.data.status}`);
                      setShowFinalData(true);
                      setHealthIdDetails(res.data);
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                    toast.error(err);
                  });
              }
            })
            .catch((error2) => {
              console.error("Error in auth_confirm_workflow:", error2);
            });
        }
      })
      .catch((error) => {
        console.error("Error in auth_init_workflow:", error);
      });
  };

  const AddCareContext = async (decodedData) => {
    // Prompt the user to enter visit purpose
    const displayValue = await showPromptDialog("Enter visit purpose");

    if (!displayValue) {
      return;
    }

    // Assuming setPurpose is a function to set the visit purpose somewhere in the state or context
    setPurpose(displayValue);

    // Initialize reqBody variable
    let reqBody = {};

    // Check if a patient is selected or needs to be matched from the patient list
    if (!selectedPatient) {
      const matchedPatient = patientList.find(
        (patient) => patient.abha_id === decodedData.hid
      );
      if (matchedPatient) {
        reqBody = {
          patient_id: matchedPatient.patient_id,
          visit_details: displayValue || "",
        };
      } else {
        console.log("No matching patient found");
        return; // Exit the function early if no patient is found
      }
    } else {
      reqBody = {
        patient_id: selectedPatient.patient_id,
        visit_details: displayValue || "",
      };
    }

    // Perform the POST request to create the care context
    try {
      const res = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}create_care_context/`,
        JSON.stringify(reqBody),
        {
          headers: headers,
        }
      );
      toast.success(
        `Visit Purpose Reference Id "${res.data.ref_num}"This ID will be used for linking to ABDM.`
      );
      console.log("Add Visit Purpose", res.data);
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  };

  return (
    <div>
      <h1 style={{ textAlign: "center" }}>Scan Card For Visit Purpose</h1>
      <div className="col-sm-12 col-md-12 col-lg-7" style={{ margin: "auto" }}>
        <div className="contact-panel mb-50">
          {isCameraOpen ? (
            <>
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={{
                  facingMode: "environment",
                }}
                style={{
                  width: "100%",
                  maxWidth: "600px",
                  height: "auto",
                  margin: "0 auto",
                  display: "block",
                }}
              />
              <div style={{ display: "flex", flexDirection: "row" }}>
                <button
                  className="btn btn__secondary btn__rounded btn__block btn__xhight mt-4"
                  onClick={handleCapture}
                  style={{ marginRight: "10px" }}
                >
                  Capture QR Code
                </button>
                <button
                  className="btn btn__secondary btn__rounded btn__block btn__xhight mt-4"
                  onClick={handleCloseCamera}
                >
                  Close Camera
                </button>
              </div>
            </>
          ) : (
            <button
              className="btn btn__secondary btn__rounded btn__block  btn__xhight mt-4"
              onClick={handleOpenCamera}
            >
              Open Camera
            </button>
          )}
          {showFinalData &&
          decodedData !== undefined &&
          decodedData !== null ? (
            <div>
              <h1 style={{ paddingLeft: "17%" }}>Patient Details</h1>
              <Table bordered responsive size="lg" style={{ width: "10%" }}>
                <TableHead
                  style={{
                    display: "grid",
                    fontWeight: "bold",
                    gridTemplateColumns:
                      "140px 160px 140px 100px 100px 100px 100px 100px", // Updated to accommodate the new column
                    justifyContent: "center",
                  }}
                >
                  <tr>ABHA Address</tr>
                  <tr>ABHA Number</tr>
                  <tr>Name</tr>
                  <tr>Gender</tr>
                  <tr>Date of birth</tr>
                  <tr>District</tr>
                  <tr>State</tr>
                  <tr>Address</tr>
                </TableHead>
                <TableBody>
                  <td
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "140px 160px 140px 100px 100px 100px 100px 100px", // Updated to accommodate the new column
                      justifyContent: "center",
                    }}
                  >
                    <tr>{decodedData.hid}</tr>
                    <tr>{decodedData.hidn}</tr>
                    <tr>{displayPatientName(decodedData.name)}</tr>
                    {decodedData.gender === "M" ? (
                      <tr>Male</tr>
                    ) : (
                      <tr>Female</tr>
                    )}
                    <tr>{decodedData.dob}</tr>
                    <tr>{decodedData["dist name"]}</tr> {/* Corrected */}
                    <tr>{decodedData["state name"]}</tr> {/* Corrected */}
                    <tr>{decodedData.address}</tr>
                  </td>
                </TableBody>
              </Table>
            </div>
          ) : (
            []
          )}

          {/* <p style={{ fontSize: "1.2em", fontWeight: "bold", paddingTop: "20px", color: "black" }}>
                        Visit Purpose ID: {healthIdDetails.reference_number}
                        {purpose && ` - Purpose: ${purpose}`}
                    </p> */}
          {healthIdDetails &&
          purpose !== undefined &&
          healthIdDetails !== null ? (
            <div>
              <h1 style={{ paddingLeft: "17%" }}>Visit Purpose Details </h1>
              <Table bordered responsive size="lg" style={{ width: "10%" }}>
                <TableHead
                  style={{
                    display: "grid",
                    fontWeight: "bold",
                    gridTemplateColumns:
                      "140px 160px 180px 100px 100px 100px 100px 180px", // Updated to accommodate the new column
                    justifyContent: "center",
                  }}
                >
                  <tr>Visit Purpose ID</tr>
                  <tr>Purpose</tr>
                  <tr>Creation Date and Time</tr>
                </TableHead>
                <TableBody>
                  <td
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "140px 160px 180px 100px 100px 100px 100px 100px", // Updated to accommodate the new column
                      justifyContent: "center",
                    }}
                  >
                    <tr>{healthIdDetails.reference_number}</tr>
                    <tr>{purpose}</tr>
                    <tr>{new Date().toLocaleString()}</tr>
                  </td>
                </TableBody>
              </Table>
            </div>
          ) : (
            []
          )}
        </div>
      </div>
    </div>
  );
};

export default QRCodeReader;
